import { render, staticRenderFns } from "./search-component.vue?vue&type=template&id=15219b08&lang=html&"
import script from "./search-component.vue?vue&type=script&lang=js&"
export * from "./search-component.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports